
import { EpimsBaseEntityDto } from './epim-base.dto';

export class CorrespondenceActionResponseDto extends EpimsBaseEntityDto {
 Comment: string;
 ActionReviewer: string;
 ActionReviewerId: string;
 DocumentId: string;
 CorrespondenceId: string;
 ActionDate: Date;
 FollowUp: boolean;
 Resolve: boolean;
 Notify: boolean;
}
